module.exports = __webpack_public_path__ + "readmeTemplates/OSH_introduction.56d611fafdefa3ec5ec2d8cab342c4a5.md";